/* ══════════════════════════════════════════════════════════════
   LEAVING AN EXERCISE MID-SESSION

   Every exercise guarded its own ✕ button and nothing else, so the
   sidebar was a trapdoor: one click on Account and a half-finished
   session was gone, with no warning and no way back.

   Router-level blocking is not available here — the app mounts a
   <BrowserRouter>, and useBlocker only works under a data router — so
   the guard is an explicit, tiny registry instead. An exercise says
   "I have unsaved work" while it does, and navigation asks before it
   leaves.

   A single slot rather than a set: only one exercise is ever on screen,
   and a stale registration from an unmounted one would block navigation
   forever. Registering hands back a token, and only that token can
   release it, so an unmount racing a fresh mount cannot clear the new
   exercise's guard.
══════════════════════════════════════════════════════════════ */

let current = null;   // { token, isDirty }

export function registerStudyGuard(isDirty) {
  const token = Symbol('study-guard');
  current = { token, isDirty };
  return token;
}

export function releaseStudyGuard(token) {
  if (current && current.token === token) current = null;
}

/* True when there is work that leaving would throw away. The predicate is
   called fresh each time rather than cached, so an exercise that has not
   been started yet — or has just finished — does not prompt. */
export function isStudyDirty() {
  try {
    return !!(current && current.isDirty());
  } catch {
    return false;   // a broken predicate must never trap the user on a page
  }
}
